import { DashboardPanel } from '@engine/lib/dashboard_panel';
import { exists } from '@engine/lib/utility/exists';

function currencyForDashboardHealth() {
  return {
    currency: $('#health-currency').val()
  };
}

function handleOverviewPanels() {
  var processingStatusPanel = new DashboardPanel('health');
  var criticalRiskFiltersPanel = new DashboardPanel('critical_filters');
  var fraudRatiosPanel = new DashboardPanel('fraud_ratios');
  var chargebackRatiosPanel = new DashboardPanel('chargeback_ratios');
  var tc40safeRatiosPanel = new DashboardPanel('tc40_ratios');
  var gmcmpRatiosPanel = new DashboardPanel('gmcmp_ratios');
  processingStatusPanel.pramsForRequest = currencyForDashboardHealth;
  processingStatusPanel.listenForShow();
  criticalRiskFiltersPanel.listenForShow();
  fraudRatiosPanel.listenForShow();
  chargebackRatiosPanel.listenForShow();
  tc40safeRatiosPanel.listenForShow();
  gmcmpRatiosPanel.listenForShow();
}

function loadDashboardHealth() {
  if (exists($('#health'))) {
    $.ajax({
      method: 'GET',
      url: '/dashboard/health',
      dataType: 'html',
      data: currencyForDashboardHealth()
    }).done(function (response) {
      $('#health').html($.parseHTML(response));
    });
  }
}

function listenForDashboardCurrencyChange() {
  $('#health-currency').on('change', function (e) {
    var toggable = $(e.target).closest('.toggable');
    var btn_hide = toggable.find('.panel-hide.hidden');
    var hidden_btn_show = toggable.find('.panel-show:not(.hidden)');
    var show_health_link = $('#show_health_link');

    if (btn_hide.length > 0 && show_health_link.length > 0) {
      show_health_link.trigger('click');
    } else {
      loadDashboardHealth();
      hidden_btn_show.trigger('click');
    }
  });
}

function listenForPaginationClick() {
  var panels_selectors = ['#chargeback_ratios', '#fraud_ratios', '#gmcmp_ratios', '#tc40_ratios'].join(', ');
  $(panels_selectors).on('click', '.pagination a', function (e) {
    e.preventDefault();
    var url = $(this).attr('href');
    var $panel = $(this).parents('.panel-body');
    var $pagination = $(this).parents('.pagination');

    if (typeof url === 'undefined') {
      return;
    }

    $.ajax({
      method: 'GET',
      url: url,
      dataType: 'html',
      beforeSend: function beforeSend() {
        var $loader = $('<div></div>').addClass('table-loader').addClass('small pagination left transparent');
        $pagination.after($loader);
      },
      success: function success(data) {
        var PADDING = 30;
        var ANIMATION_SPEED = 600;
        var $heading = $pagination.prev().prev();
        $('window, body').animate({
          scrollTop: $heading.offset().top - PADDING
        }, ANIMATION_SPEED, 'swing');
        $panel.html($(data));
      }
    });
  });
}

export { handleOverviewPanels, listenForDashboardCurrencyChange, listenForPaginationClick };